import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/IdleTimeoutModal.css';

/**
 * Modal shown when user session times out due to inactivity
 * Provides option to return to dashboard with fresh session
 */
const IdleTimeoutModal = ({ onClose }) => {
  const navigate = useNavigate();

  const handleReturnToDashboard = () => {
    // Clear any cached data
    sessionStorage.clear();
    
    // Close modal
    if (onClose) {
      onClose();
    }

    // Redirect to home dashboard
    navigate('/', { replace: true });
    
    // Force page refresh to ensure clean state
    window.location.reload();
  };

  return (
    <div className="idle-timeout-overlay">
      <div className="idle-timeout-modal">
        <div className="idle-timeout-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="12" cy="12" r="10" strokeWidth="2"/>
            <path d="M12 6v6l4 2" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        
        <h2 className="idle-timeout-title">Session Refreshed</h2>
        
        <p className="idle-timeout-message">
          Due to inactivity, we've refreshed your session to ensure you see the latest learning opportunities.
        </p>
        
        <p className="idle-timeout-submessage">
          Thank you for exploring PLM Learning Day!
        </p>

        <button 
          className="idle-timeout-button"
          onClick={handleReturnToDashboard}
          autoFocus
        >
          Return to Dashboard
        </button>

        <div className="idle-timeout-footer">
          <small>Tip: Close browser tabs when done to free up system resources</small>
        </div>
      </div>
    </div>
  );
};

export default IdleTimeoutModal;
